import type { CheckoutPaymentErrorResponse } from '@libs/common-node';

export class CheckoutPaymentError extends Error {
    readonly errorDetails: CheckoutPaymentErrorResponse;

    constructor(message: string, data: CheckoutPaymentErrorResponse) {
        super(message);

        this.errorDetails = data;
    }
}
